module.exports = __webpack_public_path__ + "media/application/images/2023/05_still-1600x900-aa3db37851c1288e50f361824442fd00.png";